<div #wc class="wc">
  <!-- AT-9303 (zwrotka 21.09): obraz wnętrza nosi klasy snippetu „Render", więc rozmiar
       ustawiony w kreatorze działa. Gdy blok go nie ma (starsza fabryka) — wymiary domyślne
       z klasy `--default-size`, czyli wygląd sprzed tej zmiany. -->
  <img #interiorImg class="wc__interior" *ngIf="interior?.imageUrl"
       [ngClass]="imageClasses"
       [class.wc__interior--default-size]="!imageClasses.length || defaultSize"
       [src]="interior.imageUrl" (load)="onImageLoad()" alt=""/>
  <img class="wc__artwork" *ngIf="cutoutPath && ready" [src]="cutoutPath" alt=""
       [class.wc__artwork--pending]="!revealArtwork"
       [style.width.px]="artworkWidthPx"
       [style.height.px]="artworkHeightPx"
       [style.transform]="artworkTransform"/>
</div>
